// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7994af9b","667":"b2104f0b","977":"72262e42"}[chunkId] + ".chunk.js";
};